import { render, staticRenderFns } from "./ManageRolesPermissions.vue?vue&type=template&id=3f9639d4"
import script from "./ManageRolesPermissions.vue?vue&type=script&lang=js"
export * from "./ManageRolesPermissions.vue?vue&type=script&lang=js"
import style0 from "./ManageRolesPermissions.vue?vue&type=style&index=0&id=3f9639d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports